import { TokenProvider } from "../TokenProvider";
import { fetchReservationAPIConfig } from "./fetchReservationAPIConfig";
import { createAxiosClient } from "../rest/AxiosClient";

// This function takes a promo code as a parameter and returns the API response
export const checkPromoCode = async (promoCode: string): Promise<any> => {
  try {
    // Obtain an anonymous token using TokenProvider
    const token = await new TokenProvider().getAnonToken();

    // Fetch API configuration using the obtained token
    const config = await fetchReservationAPIConfig(token);

    // Create an Axios client instance with the fetched configuration
    const axiosClient = await createAxiosClient({
      apiEndpoint: `${process.env.GATSBY_CDP_AUTH0_AUDIENCE}`,
    });

    // Perform a GET request to the API with the promo code as part of the URL
    const response = await axiosClient.getData(
      `/guest/promocodes/check/${promoCode}`,
      { ...config }
    );

    return response;
  } catch (error) {
    console.error("Error", error);
    throw error;
  }
};

export default checkPromoCode;
